import SendPhoneCode from '../FormComp/SendCode'
import BgGreyInput from '../FormComp/BgGreyInput'
import LeftTextAutocomplete from '../FormComp/LeftTextAutocomplete.vue'
import LeftTextBorder from '../FormComp/LeftTextBorder'
import LeftTextBorderMany from '../FormComp/LeftTextBorderMany.vue'
import LeftTextNumber from '../FormComp/LeftTextNumber.vue'
import LeftTextSelect from '../FormComp/LeftTextSelect'
import LeftTextRadio from '../FormComp/LeftTextRadio'
import LeftTextRadio2 from '../FormComp/LeftTextRadio2'
import LeftTextUnit from '../FormComp/LeftTextUnit'
import LeftTextTimespan from '../FormComp/LeftTextTimespan'
import LeftTextCheckbox from '../FormComp/LeftTextCheckbox'
import LeftTextMultipleChoice from '../FormComp/LeftTextMultipleChoice.vue'
import LeftTextBrand from '../FormComp/LeftTextBrand.vue'
import SelectCity from '../FormComp/SelectCity'
import UploadImage from '../MultimediaManage/UploadImage'
import UploadFile from '../MultimediaManage/UploadFile'
import LeftText from '../PublicComp/LeftText'
import PublicTitle from '../PublicComp/PublicTitle'
import VerifyNumber from '../Verify/number'
import Elrowlinput from '../FormComp/Elrowlinput.vue'

const components = [
  {compName: 'el-rowl-input', comp: Elrowlinput},
  {compName: 'send-phone-code', comp: SendPhoneCode},
  {compName: 'bg-grey-input', comp: BgGreyInput},
  {compName: 'left-text-border', comp: LeftTextBorder},
  {compName: 'left-text-autocomplete', comp: LeftTextAutocomplete},
  {compName: 'left-text-border-many', comp: LeftTextBorderMany},
  {compName: 'left-text-number', comp: LeftTextNumber},
  {compName: 'left-text-radio', comp: LeftTextRadio},
  {compName: 'left-text-radio2', comp: LeftTextRadio2},
  {compName: 'left-text-unit', comp: LeftTextUnit},
  {compName: 'left-text-timespan', comp: LeftTextTimespan},
  {compName: 'left-text-checkbox', comp: LeftTextCheckbox},
  {compName: 'left-text-multiple-choice', comp: LeftTextMultipleChoice},
  {compName: 'left-text-brand', comp: LeftTextBrand},
  {compName: 'left-text-select', comp: LeftTextSelect},
  {compName: 'select-city', comp: SelectCity},
  {compName: 'upload-image', comp: UploadImage},
  {compName: 'upload-file', comp: UploadFile},
  {compName: 'left-text', comp: LeftText},
  {compName: 'public-title', comp: PublicTitle},  
  {compName: 'verify-number', comp: VerifyNumber},
];
const myComponent = Vue => {
  components.forEach(Component => {
    Vue.component(Component.compName, Component.comp);
  });
};

export default myComponent;
